import styled from "styled-components";
import { Link, NavLink } from "react-router-dom";
import { Container } from '../GlobalStyle';
import { FaRecycle, FaShoppingCart } from 'react-icons/fa';

export const Nav = styled.div`
    background: #317cc0;
    width: 100%;
    height: 3.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;    
    position: sticky;
    top: 0;
    font-size: 1.2rem;
    z-index: 10;
`;

export const NavbarContainer = styled(Container)`
display:flex;
justify-content: space-between;
height:80px;
${Container}
`;

export const NavLogo = styled(Link)`
    color: #fff;
    justify-self: flex-start;
    cursor: pointer;
    text-decoration: none;
    font-size: 2rem;
    display: flex;
    align-items: center;
`;

export const NavIcon = styled(FaRecycle)`
    color: darkgreen;
    margin-left: 0.6rem;
`;

export const MobileIcon = styled.div`
display: none;

@media screen and (max-width: 768px) {
    display: block;
    position:absolute;
    top:-1;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
}
`;

export const NavMenu = styled.ul`
display:flex;
list-style: none;
text-align: center;
height:2rem;
align-items: center;
justify-content: right;

@media screen and (max-width: 768px){
    display: flex;
    flex-direction:column;
    margin-top: 3.5rem;
    background:  #317cc0;
    height: 100vh;
    position:absolute;
    align-items: center;
    left: ${({ mobileState }) => (mobileState ? 0 : '-200%')};
    opacity: 1;
    transition: all 0.5s ease;
}`;

export const NavItem = styled.li`
    height: 80px;
    border-bottom: 2px solid transparent;
    &:hover{
        border-bottom: 2px solid darkgreen;
    }

    @media screen and (max-width: 768px) {
        width: 100%;
        &:hover{
            border: none;
        }
    }`;

export const NavLinks = styled(NavLink)`
color: #fff;
display: flex;
align-items: center;
text-decoration: none;
padding: 0.5rem 1rem;
height: 100%;
&.active {
    color: black;
}
@media screen and (max-width: 768px){
    text-align: center;
    padding: 2rem;
    
    display: table;

    &:hover{
        color: #4b59f7;
        transition: all 0.3s ease;
    }
}`;

export const CartIcon = styled(FaShoppingCart)`
    color: white;
    width: 100%;
&:hover {
    color: #4b59f7;
    transition: all 0.3s ease;
}`;

export const NavItemBtn = styled.li`
color: #fff;
justify-self: flex-start;
cursor: pointer;
margin-top:1rem;
text-decoration: none;
font-size: 2rem;
display: flex;
align-items: center;
@media screen and (max-width: 768){
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100% auto;
    height: 120px;
}`;

export const NavBtnLink = styled(Link)`
display:flex;
justify-content:center;
align-items: center;
text-decoration: none;
margin-top:0.7rem;
padding: 1px 16px;
height: 100%;
width: 100% auto;
border: none;
outline: none;
`;
